export default function getResource(label, vars = []) {
    const resources = {
        freeReturnsMessage: 'Retours gratuits en ligne ou en magasin dans un délai de 30 jours',
        freeReturnsAriaLabel: 'Retours gratuits en ligne ou en magasin dans un délai de 30 jours. Consultez les détails de la politique de retour.'
    };

    return resources[label];
}
